<template>
  <el-table-column
    prop="currency_code"
    sortable="custom"
    label="Deviza"
    show-overflow-tooltip
    min-width="90"
  >
    <template slot-scope="scope">
      {{ scope.row.currency_code }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'currency_code',
};
</script>
